'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002491 from "./presto.types$$anon$91.js";
import * as $j_presto$002etypes$0024$002dAllow$002dPayload$0024 from "./presto.types$-Allow-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$90(outer) {
  this.c9q = null;
  this.c9i = null;
  this.c9j = false;
  this.c9r = null;
  this.c9s = false;
  this.c9v = null;
  this.c9o = null;
  this.c9p = false;
  this.c9k = null;
  this.c9l = false;
  this.c9m = null;
  this.c9n = false;
  this.c9t = false;
  this.c9u = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.c9q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c9v = "AllowPayload";
}
export { $c_Lpresto_types$Rule$$anon$90 as $c_Lpresto_types$Rule$$anon$90 };
$p = $c_Lpresto_types$Rule$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$90;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$90() {
}
export { $h_Lpresto_types$Rule$$anon$90 as $h_Lpresto_types$Rule$$anon$90 };
$h_Lpresto_types$Rule$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c9q;
});
$p.M = (function() {
  if ((!this.c9j)) {
    this.c9i = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c9j = true;
  }
  return this.c9i;
});
$p.O = (function() {
  if ((!this.c9s)) {
    this.c9r = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c9s = true;
  }
  return this.c9r;
});
$p.E = (function() {
  return this.c9v;
});
$p.t = (function() {
  if ((!this.c9p)) {
    this.c9o = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.c9p = true;
  }
  return this.c9o;
});
$p.N = (function() {
  if ((!this.c9l)) {
    this.c9k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().Sy(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.c9l = true;
  }
  return this.c9k;
});
$p.Q = (function() {
  if ((!this.c9n)) {
    this.c9m = new $j_presto$002etypes$0024$0024anon$002491.$c_Lpresto_types$$anon$91();
    this.c9n = true;
  }
  return this.c9m;
});
$p.v = (function() {
  if ((!this.c9u)) {
    this.c9t = false;
    this.c9u = true;
  }
  return this.c9t;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee90) => ((p) => \u03b4scrutinee90.cFI(p)))($j_presto$002etypes$0024$002dAllow$002dPayload$0024.$m_Lpresto_types$AllowPayload$())));
});
var $d_Lpresto_types$Rule$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$90, "presto.types$Rule$$anon$90", ({
  a1z: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$90 as $d_Lpresto_types$Rule$$anon$90 };
//# sourceMappingURL=presto.types$-Rule$$anon$90.js.map
